<template>
    <footer class="footer" style="margin-top: -50px;" id="footer">
        <div class="container-fluid">
            <div class="copyright float-sm-left">
                 Copyright &copy; ILYGuts Corporation {{currentYear}}
            </div>
            <div class="copyright" id="copyright">
                Design and Maintenance by <a target="_blank" href="https://mythicaldev.com/">Mythical Development</a>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        name: 'Footer',
        data: () => {
            return {
                currentYear: new Date().getFullYear()
            }
        }
    }
</script>